import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private st = window.sessionStorage;

  constructor() {}

  public setItem(key, value) {
    value = JSON.stringify(value);
    this.st.setItem(key, value);
    return true;
  }

  public getItem(key) {
    const value = this.st.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  public clear() {
    this.st.clear();
  }
}
